import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  AUTH_CHECKING_MESSAGE,
  HOME_PAGE,
  INFORMATION_PAGE,
  SERVER_DOWN,
  SUBSCRIPTION_PAGE,
} from "../../Constants";
import * as authService from "../../actions/auth.actions.js";
import * as utilityService from "../../actions/utility.actions.js";
import Loading from "../../layout/Loading";

export default function SubscriptionSuccess({ isAuthenticated }) {
  const [searchParams] = useSearchParams();
  const [isCheckoutSessionValid, setIsCheckoutSessionValid] = useState(false);
  const redirectToHome = () => {
    window.location.href = HOME_PAGE;
  };
  const redirectToHowToUse = () => {
    window.location.href = INFORMATION_PAGE;
  };
  useEffect(async () => {
    async function validateCheckoutSession() {
      const response = await utilityService.verifyCheckoutSession({
        stripe_session_id: searchParams.get("session_id"),
      });

      if (!response) {
        console.log(SERVER_DOWN);
        return;
      }

      if (response.data.success && response.data.stripeCheckoutSessionIsValid) {
        setIsCheckoutSessionValid(true);
        authService.reloadAuthToken();
        return true;
      }
      return false;
    }

    if (isAuthenticated) {
      const isValidSessionId = await validateCheckoutSession();

      if (!isValidSessionId) {
        window.location.href = SUBSCRIPTION_PAGE;
      }
    }
  }, [isAuthenticated]);

  return isAuthenticated && isCheckoutSessionValid ? (
    <div style={{ display: "inline-block" }}>
      <h1 className="extra-large-font" style={{ color: "green" }}>
        Thank you for subscribing!
      </h1>
      <div>
        <h2 style={{ wordBreak: "break-all" }} className="font-weight-normal">
          <i>Checkout id: {searchParams.get("session_id")}</i>
        </h2>
        <br />

        <h2 className="font-weight-normal">
          You are all set! Please use the links below to redirect
        </h2>
        <br />

        <a onClick={redirectToHome} className="buttonGreen">
          BEGIN
        </a>
        <a onClick={redirectToHowToUse} className="buttonPrimary">
          HOW TO USE
        </a>
      </div>
    </div>
  ) : (
    <Loading text={AUTH_CHECKING_MESSAGE} />
  );
}
